import Title from "components/Title";
import Button from "components/Button";
import React from "react";
import Section from "Section";
import BUSINESSMAN_RUHACKS from "./media/businesseggward1.png";

import SPONSORS from "./sponsors";
export default function Sponsorship() {
  return (
    <Section bcolor="#27313B">
      <div className="sponsors-anchor" id="sponsors" />
      <div className="sponsors-title">
        <div className="sponsors-title__tit">
          <Title text="Our Sponsors" />
        </div>
        <img
          src={BUSINESSMAN_RUHACKS}
          alt=""
          className="sponsors-title__image"
        />
      </div>
      <div className="sponsors">
        <div className="sponsors-intro">
          By sponsoring RU Hacks, your contribution will empower students of all
          experience levels and backgrounds with the mentorship and resources to
          create projects they're passionate about. Engage with the next
          generation of innovators and help us unite over 800 emerging
          developers, designers, and builders.
        </div>
        <div className="sponsors-interest">
          <strong>
            Interested in sponsoring? Email us at{" "}
            <a href="mailto:sponsors@ruhacks.com">sponsors@ruhacks.com</a>
          </strong>
          <div className="sponsors-interest__button">
            <Button
              text="Become a Sponsor"
              href="https://ruhacks.com/sponsorship/"
            />
          </div>
        </div>
        <div className="sponsors-con">
          <div className="sponsors-con__title">
            {/* Special thanks to our sponsors! */}
            Thank you sponsors for supporting RU Hacks
          </div>
          {SPONSORS.map((d) => (
            <SponsorsLogo {...d} />
          ))}
        </div>
      </div>
    </Section>
  );
}

function SponsorsLogo({ logo, size, link, name }) {
  return (
    <a
      href={link}
      className={`sponsors-con__image ${size}`}
      style={{ backgroundImage: `url(${logo})` }}
      title={name}
    >
      {" "}
    </a>
  );
}
